import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import Pagination from 'components/Libs/Pagination';

import styles from 'styles';

import { searchStatisticsUsers } from 'actions/statistics/users'

import StatisticsUsersRow from './Row';

class StatisticsUsersTable extends React.Component {
    constructor(props) {
        super(props);

        const { statisticsUsers, searchText } = props;

        this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: statisticsUsers.length,
            statisticsUsers: this.filterSearch(statisticsUsers, searchText),
        };

        this.handleUpdateRow = this.handleUpdateRow.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    filterSearch(items, searchText) {
        if (!searchText) {
            return items;
        }
        return items.filter((item) => {
            if (item.name && item.name.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }

            if (item.surname && item.surname.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }

            if (item.email && item.email.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }

            if (_.has(item, 'item.company.name') && item.company.name.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }

            if (_.has(item, 'item.phones[0].phone') && item.phones[0].phone.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }

            return false;
        });
    }

    componentDidMount() {
        this.handleUpdateRow(this.state);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { statisticsUsers, searchText } = nextProps;
        
        let { page } = this.state;

        if (searchText !== this.props.searchText) {
            page = 1;
        }

        this.setState({
            searchText,
            statisticsUsers: this.filterSearch(statisticsUsers, searchText),
            page,
            total: statisticsUsers.length,
        }, () => {
            this.handleUpdateRow(this.state);
        });
        
    }

    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return this.state.statisticsUsers.slice(from, to);
    }

    handleUpdateRow(newState) {
        const rows = this.changeRowsByPagination(newState);
        const state = newState;
        state.rows = rows;

        this.setState(state);
    }

    handleSearch(e, value) {
       this.props.searchStatisticsUsers(value);
    }

    render() {
        const { rows, rowsPerPage, statisticsUsers, page, numberOfRows } = this.state;
        const { searchText } = this.props;

        let sumUsersVerified = 0;
        let sumUsersEnterOnSite = 0;
        let sumRegistrations = 0;

        statisticsUsers.forEach((user) => {
           if (user.emailVerified) {
               sumUsersVerified += 1;
           }
            if (user.password) {
                sumUsersEnterOnSite += 1;
            }

            if (user.createdAt) {
                sumRegistrations += 1;
            }
        });

        let renderPagination = (<Pagination
            total={statisticsUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            numberOfRows={numberOfRows}
            updateRows={this.handleUpdateRow}
        />);

        let renderTable = (<Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Name
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Surname
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Email
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Company
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Organization
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Country
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Phone
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Registration date
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Email verified
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Email verified date
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Login
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Current subscription
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Subscription starts
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        Subscription ends
                    </TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
                {
                    rows.map((row, index) => {
                        return (<StatisticsUsersRow
                            key={row._id + index}
                            item={row}
                        />);
                    })
                }
            </TableBody>
        </Table>);

        return (
            <div>
                <div className='table-header'>
                    <div className='item'>
                        <p>In this dates range:</p>
                        <p>Verified emails - {sumUsersVerified}</p>
                        <p>Enter on site - {sumUsersEnterOnSite}</p>
                        <p>Registration - {sumRegistrations}</p>
                    </div>
                    <div className='item'>
                        <TextField
                            defaultValue={searchText}
                            floatingLabelText='Search'
                            onChange={this.handleSearch}
                        />
                    </div>
                    <div className='item'>
                        {renderPagination}
                    </div>
                </div>

                <div className='table-body'>
                    {renderTable}
                </div>
            </div>
        );
    }
}

export default connect(
    ({ statisticsUsers: { items, searchText }}) => {
        return {
            statisticsUsers: items,
            searchText,
        };
    },
    dispatch => bindActionCreators({
            searchStatisticsUsers
    },
    dispatch),
)(StatisticsUsersTable);



// WEBPACK FOOTER //
// ./app/components/Statistics/Users/Table/Table.jsx